/* eslint no-undef: 0 */
import Immutable from 'immutable';
const API_KEYS = window.vfEnvironmentConfig;

class GoogleAnalytics {
    constructor(key) {
        this.key = key;
    }

    activate() {
        /*eslint-disable */
        /** google's code **/
        (function(i, s, o, g, r, a, m) {
            i['GoogleAnalyticsObject'] = r;

            if (!i[r]) {
                i[r] = function() {
                    (i[r].q = i[r].q || []).push(arguments);
                };

                i[r].l = 1 * new Date();
            }

            a = s.createElement(o);
            a.setAttribute('type', 'text/plain')
            a.setAttribute('data-cookiescript', 'accepted')
            m = s.getElementsByTagName(o)[0];
            a.async = 1;
            a.src = g;
            m.parentNode.insertBefore(a, m);
        })(
            window,
            document,
            'script',
            'https://www.google-analytics.com/analytics.js',
            'ga'
        );

        window.ga('create', this.key, 'auto');
        window.ga('send', 'pageview');
        /*eslint-enable */
    }

    track(action, opts) {
        window.ga('send', 'event', opts.category, action, opts.label, opts.value);
    }

    pageView(location) {
        window.ga('send', 'pageview', location);
    }
}

class GTM {
    constructor(key) {
        this.key = key;
    }

    track(action, opts) {
        window.dataLayer.push({
            category: opts.category,
            event: action,
            label: opts.label,
            value: opts.value,
        });
    }

    pageView(location) {
        window.dataLayer.push({
            event: 'Loaded a Page',
            path: location,
            url: window.location.href,
            title: document.title,
            referrer: document.referrer,
        });
    }

    activate() {
        window.dataLayer = window.dataLayer || [];

        window.dataLayer.push({
            'gtm.start': new Date().getTime(),
            event: 'gtm.js',
        });

        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.async = true;
        script.src = `//www.googletagmanager.com/gtm.js?id=${this.key}&l=dataLayer`;
        const first = document.getElementsByTagName('script')[0];
        first.parentNode.insertBefore(script, first);
    }
}

const integrations = Immutable.List([
    new GoogleAnalytics(API_KEYS.GOOGLE_ANALYTICS_KEY),
    new GTM(API_KEYS.GOOGLE_TAG_MANAGER),
]);

export function activate() {
    integrations.forEach(integration => integration.activate());
}

export function track(action, opts) {
    integrations.forEach(integration => integration.track(action, opts));
}

export function pageView(pathname, url) {
    integrations.forEach(integration => integration.pageView(pathname, url));
}



// WEBPACK FOOTER //
// ./src/services/EventHandler.js